import React from 'react';
import SectionHeading from '../common/section-heading-component';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { ButtonVariants } from '../../Atoms/Button';
import { ITR_FILING_SERVICES_DATA } from './constants';
import { ITRServicesSectionProps, ITRServiceData } from '../types';

const ITRServicesSection: React.FC<ITRServicesSectionProps> = ({
  data = ITR_FILING_SERVICES_DATA,
}) => {
  const { heading, description, ctaText, ctaLink, services } = data;

  return (
    <div className="bg-gray-100 py-16 xl:py-24 lg:py-24 md:py-24">
      <div className=" mx-auto px-4 flex flex-col items-center">
        {/* Header */}
        <SectionHeading
          heading={heading}
          subHeading={description}
          classname="sm:text-left text-center"
        />

        <div className="w-5/6 justify-center sm:w-full sm:justify-start">
          {/* Description */}

          <div className="flex pt-16 sm:flex-col justify-center">
            {/* Services Section */}
            <div className="w-1/2 sm:w-full">
              <p className="text-font-500 font-bold text-3xl sm:text-2xl text-center mb-8">
                For You
              </p>

              {/* Services List */}
              <div className="space-y-6">
                {services.map((item: ITRServiceData, index: number) => (
                  <div key={index} className="flex pt-6 px-4 sm:w-full sm:px-0">
                    {/* Icon */}
                    <div className="w-1/6 xl:w-1/12 flex-shrink-0">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="h-8 w-8 object-contain"
                      />
                    </div>

                    {/* Content */}
                    <div className="px-6 w-5/6 sm:pr-0">
                      <p className="text-font-500 font-bold text-lg mb-2">
                        {item.title}
                      </p>
                      <p className="text-base pt-2 text-font-200 leading-relaxed w-4/5">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-12 w-2/5 md:mt-6 md:w-full sm:w-full sm:mt-5 lg:w-3/5">
                <ButtonWithAnchor
                  buttonText={`${ctaText} →`}
                  buttonLink={ctaLink}
                  trackLabel="itr_services_cta"
                  buttonVariant={ButtonVariants.bluetext}
                  target="_blank"
                  className="py-3 px-6 font-semibold flex justify-start"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ITRServicesSection;
